import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";

export interface RoleBatchActionHandlers {
  onDelete: () => void;
}

export const buildRoleBatchActions = (
  _selectedCount: number,
  handlers: RoleBatchActionHandlers
): BatchAction[] => [
  {
    icon: faTrashCan,
    label: "Delete",
    onClick: handlers.onDelete,
    variant: "danger",
  },
];
